import {useEffect, useState} from 'react';

import {Observable} from 'services';

export function useObservable<T>(observable: Observable<T>) {
    const [value, setValue] = useState<T>(observable.getValue());
    useEffect(() => observable.subscribe(setValue), [observable]);
    return value;
}
